export default __webpack_public_path__ + "static/media/cardio-icon.74400ab8.svg";